import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  template: `
    <h2 mat-dialog-title>Confirmación</h2>
    <mat-dialog-content>¿Estás seguro de solicitar el servicio?</mat-dialog-content>
    <mat-dialog-actions class="actions">
      <button mat-button  [mat-dialog-close]="true">Aceptar</button>
      <button mat-button  [mat-dialog-close]="false">Cancelar</button>
    </mat-dialog-actions>
  `,
  styles: [`
    .actions {
      display: flex;
      justify-content: space-between;
    }
    .mat-mdc-button {
        color:#0E365A
    }
  `]
})
export class AsisstancesConfirmDialogComponent {}